import { createStore } from 'vuex'

export default createStore({
  state: {
    selectedMikve:0
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
